import React, {useState, useRef, Fragment} from 'react';
import {Button} from 'devextreme-react/button';
import {Popup, ToolbarItem} from 'devextreme-react/popup';
import List from 'devextreme-react/list';
import {Item, Label} from 'devextreme-react/form';
import './index.scss';
import ScrollView from 'devextreme-react/scroll-view';
import amazonIcon from '../../../../assets/amazon_icon.jpg';
import ebayIcon from '../../../../assets/ebay_icon.png';
import shopifyIcon from '../../../../assets/shopify_icon.png';
import etsyIcon from '../../../../assets/etsy_icon.png';
import aliExpressIcon from '../../../../assets/aliExpress_icon.jpg';
import Amazon from '../amazon/index';
import Shopify from '../shopify/index';
import Ebay from '../ebay/index';
import Etsy from '../etsy/index';
import DataGrid, {Column, Popup as GridPropUp, Button as GridButton, Editing, Position, Form as GridForm} from 'devextreme-react/data-grid';
import url from '../../../../api/base-url';
import storesApi from '../../../../api/stores';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import CustomStore from 'devextreme/data/custom_store';
import sessions from '../../../../sessions';
import 'whatwg-fetch';

const MarketList = [
    {
        "key": 1,
        "name": "Amazon",
        "img": amazonIcon
    }, {
        "key": 2,
        "name": "Ebay",
        "img": ebayIcon
    }, {
        "key": 3,
        "name": "Shopify",
        "img": shopifyIcon
    }, {
        "key": 4,
        "name": "Etsy",
        "img": etsyIcon
    },{
        "key": 5,
        "name": "AliExpress",
        "img": aliExpressIcon
    }
];

const SellingChannelList = () => {
    const [isPopUpVisible, setIsPopUpVisible] = useState(false);
    const [contentID, setContentID] = useState([]);
    const childRef = useRef();
    
    const  SellingChannel = () =>{
        switch(contentID){
            case 'Amazon': 
                return(<Amazon ref={childRef}/>);
            case 'Shopify':
                return(<Shopify ref={childRef}/>);
            case 'Ebay':
                 return(<Ebay ref={childRef}/>);
            case 'Etsy': 
                return(<Etsy ref={childRef}/>);
            {/*
            case 'AliExpress':
                return(<AliExpress ref={childRef}/>);
             */}
            default:
                return 'Error 404 Page Not Found';
        }
     }

    function onSelectedItemKeysChange(args) {
        if (args?.name === 'selectedItemKeys') {
            console.log("args", args);
            if (args?.value[0]) {
                var item = args.value[0];
                setContentID(item.name);
                setIsPopUpVisible(true);
            }
        }
    }

    function onInitialized(){
        setContentID('');
    }
    function listChannel(item) {
        return (
            <div className={'list-channel'} key={item.key}>
                <div><img className={'channel-img'} alt={item.name} src={item.img}/></div>
                <div>{item.name}</div>
            </div>
        )
    }

    const cancelButton = {
        text: 'cancel',
        onClick: () => {setContentID('');setIsPopUpVisible(false);}
    }

    const connectButton = {
        text: 'connect',
        useSubmitBehavior: true,
        validationGroup: 'group',
        onClick: () => childRef
            .current
            .onSubmit()
    }

    return (
        <React.Fragment>
            <Popup
                title={`Connect Your ${contentID} Channel`}
                visible={isPopUpVisible}
                contentRender={SellingChannel}
                onHiding={e => { setContentID('');setIsPopUpVisible(false)}}>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={connectButton}></ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={cancelButton}>
                </ToolbarItem>
            </Popup>
            <ScrollView width="100%" height="100%">
                <List
                    dataSource={MarketList}
                    itemRender={listChannel}
                    onInitialized={onInitialized}
                    searchExpr="name"
                    searchEnabled={true}
                    searchMode={'contains'}
                    selectedItemKeys={contentID}
                    selectionMode={'single'}
                    onOptionChanged={onSelectedItemKeysChange}/>
            </ScrollView>
        </React.Fragment>
    );
}

export default function StoreSetUps() {
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const [isPopUpVisible, setIsPopUpVisible] = useState(false);
    const [loadIndicatorVisible, setLoadIndicatorVisible] = useState(false);
    const [buttonText, setButtonText] = useState('');
    const [ID, setID] = useState('');
    function getConfig(options) {  
        options.onBeforeSend = function(method, ajaxOptions) {  
            ajaxOptions.headers = {  
               
            }  
        }  
        return options;  
    };
    const dataSource = new CustomStore(getConfig({
        key: '_id',
        load: () => {
            return fetch(`${url}/settings/stores/${encodeURIComponent(userId)}`,
            {
                headers: {
                    "x-access-token": auth
                }
            }
            ).then(response => response.json());
        },
        update: (key,values) => {
            return fetch(`${url}/settings/store/${encodeURIComponent(key)}`,
            {
                method: "PUT",
                body: JSON.stringify(values),
                headers: {
                    'Content-Type': 'application/json',
                    "x-access-token": auth
                }
            })
        },
        remove: (key) =>{
            return fetch(`${url}/settings/store/${encodeURIComponent(key)}`,
            {
                method: "DELETE",
                headers: {
                    'Content-Type': 'application/json',
                    "x-access-token": auth
                }
            })
        } 
    }))

    const onCellPrepared = (e) =>{
        if (e.rowType === "header" && e.column.command === "edit") {  
            e.cellElement.textContent = "Store Setup";  
          }  
    }

    const syncOrders = (id) =>{
        console.log("sync order",id);
        try{
            setID(id);
            setLoadIndicatorVisible(true);
            setButtonText("synchronize");
            (async()=>{
                await storesApi.syncAllOrdersinStore(id,userId,auth).then(result => {
                    //console.log(result);
                    setLoadIndicatorVisible(false);
                }).catch(err=>{
                    setLoadIndicatorVisible(false);
                });
            })();
        }catch(err){
            setLoadIndicatorVisible(false);
        }
       
    };

    const lastSyncRender = (data) => {
        var id = data?.data?._id;
        var lastModified = (new Date(data.data.lastSync?data.data.lastSync: data.data.modifiedTime)).toLocaleDateString();
        
        return(
            <div>
                 {loadIndicatorVisible && id === ID?
                 <div>
                    <LoadIndicator id="small-indicator" visible={loadIndicatorVisible} height={10} width={10} />
                    <span className="dx-button-text">{buttonText}</span>
                 </div>:
                 <div>
                     <span>{lastModified}</span>
                 </div>}
            </div>
        );
    };



    return (
        <Fragment>
            <h4 className={'content-block'}>Store Setup</h4>
            <Popup
                title="Connect Selling Channel"
                visible={isPopUpVisible}
                width={500}
                onHiding={e => setIsPopUpVisible(false)}>
                    <SellingChannelList/>
            </Popup>
            <div className={'content-block'}>
                <Button
                    type={'default'}
                    visible={false}
                    text={' + Connect a Store or Marketplace'}
                    onClick={e => setIsPopUpVisible(true)}/>
            </div>
            <div className={'content-block'}>
                <DataGrid width="85%" className={'dx-card wide-card'} dataSource={dataSource} onCellPrepared={onCellPrepared}>
                    <Editing mode="popup" allowUpdating={true} allowDeleting={true}>
                        <GridPropUp title="Store Setup" showTitle={true} width={700} height={525}>
                            <Position my="top" at="top" of={window}/>
                        </GridPropUp>
                        <GridForm>
                            <Item itemType="group" colCount={2} colSpan={2} labelPosition={'left'}>
                                <Item dataField={'type'} 
                                    editorOptions={{
                                        stylingMode:'filled',
                                        height:40
                                    }}>
                                    <Label text={'Store Type'}/>
                                </Item>
                                <Item dataField={'name'} 
                                    editorOptions={{
                                        stylingMode:'filled',
                                        height:40
                                    }}></Item>
                                <Item dataField={'modifiedTime'} visible={false}/>
                                <Item dataField={'status'}/>
                                <Item dataField={'isSyncAuto'}/>
                            </Item>
                        </GridForm>
                    </Editing>
                    <Column dataField={'type'} caption={"Store Type"}/>
                    <Column dataField={'name'} caption={"Store Name"}/>
                    <Column dataField={'modifiedTime'} caption={"Last Modified"} dataType="date"/>
                    <Column dataField={'status'}/>
                    <Column dataField={'isSyncAuto'} caption={'Sync Automatically'} dataType={'boolean'}/>
                    <Column dataField={'lastSync'} dataType={'datetime'} cellRender={lastSyncRender}/>
                    <Column type="buttons">
                        <GridButton
                            id="syncOrder"
                            hint="manually synchronize" 
                            icon={'refresh'}
                            onClick={(e) =>{syncOrders(e?.row?.data?._id)}}
                        >
                        </GridButton>
                        <GridButton name="edit" />
                        <GridButton name="delete" />
                    </Column>
                </DataGrid>
            </div>
        </Fragment>
    )
}